import OnlinePaymentResourceModel from '../../generated/types/model/resource/OnlinePaymentResourceModel';

export default class OnlinePaymentResourceViewModel extends OnlinePaymentResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
